module.exports = __webpack_public_path__ + "img/avatar.3af96d92.png";